import { render, staticRenderFns } from "./pl-date-header.vue?vue&type=template&id=223a0223&"
import script from "./pl-date-header.vue?vue&type=script&lang=js&"
export * from "./pl-date-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports